<dx-popup
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  title="Fermetures non enregistrées — plans de production existants"
  [width]="'auto'"
  [height]="'auto'"
  [maxHeight]="'80vh'"
  [maxWidth]="'80vh'"
  [showCloseButton]="true"
  [dragEnabled]="true"
  [resizeEnabled]="true">
  <dxi-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{text: 'Fermer', onClick: visible.set.bind(visible, false)}">
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <p class="yo-text-warning">
      Les fermetures suivantes n'ont pas été enregistrées car il existe des plans de production pour ces dates de fermeture.
    </p>
    <dx-data-grid
      [dataSource]="erreurs()"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [allowColumnResizing]="true"
      [columnAutoWidth]="true"
      [hoverStateEnabled]="true">
      <dxi-column dataField="fermeture.clientLibelle" caption="Client"></dxi-column>
      <dxi-column dataField="fermeture.pointLivraisonLibelle" caption="Point de livraison"></dxi-column>
      <dxi-column dataField="fermeture.prestationLibelle" caption="Prestation"></dxi-column>
      <dxi-column dataField="fermeture.dateDebut" caption="Date début" dataType="date" format="dd/MM/yyyy" [width]="120"></dxi-column>
      <dxi-column dataField="fermeture.dateFin" caption="Date fin" dataType="date" format="dd/MM/yyyy" [width]="120"></dxi-column>
      <dxi-column dataField="planProductionNames" caption="Plans de production" cellTemplate="plansCellTemplate"></dxi-column>
      <div *dxTemplate="let cell of 'plansCellTemplate'">
        {{ cell.value.join(', ') }}
      </div>
    </dx-data-grid>
  </div>
</dx-popup>
